import { showNotice } from '../services/appNotice'
import { SITE_URL } from '../constants/site'

// The demo build (vite.config.demo.ts) is the full web app with no account,
// no cloud and no saving. IS_DEMO is a build-time constant, so `if (IS_DEMO)`
// branches in scripts are dropped from the real app. (Template `v-if`s on it
// stay in as dead branches; Vue does not fold imported constants.)
export const IS_DEMO = import.meta.env.VITE_DEMO === 'true'

/** Where the demo's "get the app" links point: the store site. */
export const DEMO_SITE_URL = SITE_URL

/**
 * The demo points the API at this unresolvable host (see vite.config.demo.ts),
 * and demoNetworkGuard.ts refuses any request to it, so no account or sync
 * request can leave the browser even if some path forgets to check IS_DEMO.
 */
export const DEMO_API_HOST = 'demo-api.invalid'

export const DEMO_EXPORT_MESSAGE = 'Exporting isn’t available in the demo. Get Superelectric Ink to keep your writing.'

/**
 * In the demo, explains that exporting is unavailable and returns true so the
 * caller stops. Called before an export's setup dialog, and again where a
 * file would be written, so no path can hand the writer a file.
 */
export function demoBlocksExport(): boolean {
  if (!IS_DEMO) return false
  showNotice({ message: DEMO_EXPORT_MESSAGE })
  return true
}
